import { render, staticRenderFns } from "./CoverImageDeleteConfirmDialog.vue?vue&type=template&id=8d7b80ca&scoped=true"
import script from "./CoverImageDeleteConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./CoverImageDeleteConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./CoverImageDeleteConfirmDialog.vue?vue&type=style&index=0&id=8d7b80ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7b80ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d7b80ca')) {
      api.createRecord('8d7b80ca', component.options)
    } else {
      api.reload('8d7b80ca', component.options)
    }
    module.hot.accept("./CoverImageDeleteConfirmDialog.vue?vue&type=template&id=8d7b80ca&scoped=true", function () {
      api.rerender('8d7b80ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/novel/CoverImageDeleteConfirmDialog.vue"
export default component.exports